import { render, staticRenderFns } from "./StreamContainerH5.vue?vue&type=template&id=2855951a&scoped=true"
import script from "./StreamContainerH5.vue?vue&type=script&setup=true&lang=ts"
export * from "./StreamContainerH5.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StreamContainerH5.vue?vue&type=style&index=0&id=2855951a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2855951a",
  null
  
)

export default component.exports